import { endpoints } from "@/lib/api";

let loading = null;

// Loads the Google Maps JS API once (key served by our backend). Resolves to window.google.maps, or null if no key / blocked.
export const loadGoogleMaps = () => {
  if (window.google?.maps?.Map) return Promise.resolve(window.google.maps);
  if (loading) return loading;
  loading = endpoints.mapsConfig().then(({ data }) => new Promise((resolve) => {
    if (!data.googleMapsKey) return resolve(null);
    window.__bbkGmapsReady = () => resolve(window.google.maps);
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(data.googleMapsKey)}&callback=__bbkGmapsReady&loading=async&v=weekly`;
    s.async = true;
    s.onerror = () => resolve(null);
    window.gm_authFailure = () => resolve(null);
    document.head.appendChild(s);
  })).catch(() => null);
  return loading;
};

export const RW_CENTER = { lat: -1.9441, lng: 30.0619 };

export const pinSvg = (color = "#E11D2A") => ({
  path: "M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7z", fillColor: color, fillOpacity: 1,
  strokeColor: "#fff", strokeWeight: 2, scale: 1.6, anchor: { x: 12, y: 22 },
});

export const DARK_STYLE = [
  { elementType: "geometry", stylers: [{ color: "#1d2230" }] }, { elementType: "labels.text.fill", stylers: [{ color: "#9aa4b5" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#0a0c10" }] }, { featureType: "road", elementType: "geometry", stylers: [{ color: "#2c3446" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#0e1626" }] }, { featureType: "poi", stylers: [{ visibility: "simplified" }] },
];
